import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'allas-servicio-baterias',
  imports: [CommonModule],
  template: `
    <main class="flex flex-col gap-2 mt-12">
      @for (servicio of servicios; track servicio.title) {
      <section class="flex flex-col xl:flex-row my-6 xl:my-12">
        <div
          class="{{
            servicio.bgColor
          }} p-6 xl:p-12 flex flex-col items-center justify-center flex-auto xl:h-[500px]"
          [ngClass]="{
            'xl:order-1': servicio.left,
            'xl:order-2': !servicio.left
          }"
        >
          <main class="flex flex-col">
            <article class="grid grid-cols-12 gap-6">
              <span
                class="col-span-12 xl:col-span-2 flex items-center justify-center"
              >
                <img
                  [src]="servicio.icon"
                  [alt]="servicio.title"
                  class="h-12 xl:h-20 w-auto"
                />
              </span>
              <span class="flex flex-col col-span-12 xl:col-span-10">
                <h2
                  class="text-base xl:text-4xl font-bold fs-condensed text-center xl:text-left"
                >
                  {{ servicio.title }}
                </h2>
                <p
                  class="text-xs xl:text-base font-light text-center xl:text-left"
                >
                  <span [innerHTML]="servicio.description"></span>
                </p>
              </span>
            </article>
          </main>
        </div>
        <div
          class="h-auto xl:h-[500px]"
          [ngClass]="{ 'order-1': !servicio.left, 'order-2': servicio.left }"
        >
          <img
            [src]="servicio.img"
            alt="ambos-filtros"
            class="h-full w-auto object-cover"
          />
        </div>
      </section>
      }
    </main>
  `,
})
export class ServicioBaterias {
  servicios = [
    {
      left: false,
      icon: '/allas-icons/checklist.svg',
      title: 'DIAGNÓSTICO GRATUITO DE BATERÍAS',
      description:
        '<p class="opacity-90">Analisis completo del estado de tu batería en 5 minutos con equipos especializados</p> <strong class="font-bold">Confía en la mejor opcion de baterías en Honduras </strong>',
      img: '/images/services/diagnostico-instalacion-baterias/necesita-carga.webp',
      bgColor: 'bg-white',
    },
    {
      left: true,
      icon: '/allas-icons/lightning.svg',
      title: 'CARGA GRATUITA DE BATERÍAS',
      description:
        '<p class="opacity-90">Recupera la vida de tu Batería después de una descarga <br class="hidden xl:block" /> Carga tu batería con equipos especializados en cualquiera de <br class="hidden xl:block" /> nuestras Sucursales. Servicio completamente gratuito.',
      img: '/images/services/diagnostico-instalacion-baterias/conectando-bateria.webp',
      bgColor: 'xl:bg-[#f3f4f6]',
    },
    {
      left: false,
      icon: '/allas-icons/tools.svg',
      title: 'INSTALACIÓN PROFESIONAL GRATUITA',
      description:
        '<strong class="font-bold">Instalación técnica incluida con la compra de tu nueva batería. Técnicos certificados. </strong> <br class="hidden xl:block" /><p class="opacity-90">Limpieza y fijación correcta de la Batería / Diagnostico del Sistema de Carga del Vehículo <br class="hidden xl:block" /> Diagnostico del Sistema de Arranque del Vehículo / Activación de tu Garantía</p>',
      img: '/images/services/diagnostico-instalacion-baterias/instalando-bateria.webp',
      bgColor: 'bg-white',
    },
  ];
}
